import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardText,
  CardHeader,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import axios from "axios"
import { API_URL, sitename } from "constants/constants"
import { FiltersCard } from "../CustomersReport/Filters"
import moment from "moment"

const CustomersReport = props => {
  const [customerReports, setCustomerReports] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [totalNewUsers, setTotalNewUsers] = useState(0)
  const [totalBets, setTotalBets] = useState(0)
  const [totalStakes, setTotalStakes] = useState(0)
  const [totalWonStakes, setTotalWonStakes] = useState(0)
  const [loadingMessage, setLoadingMessage] = useState(false)
  const [total, setTotal] = useState(0)
  const [nextPageUrl, setNextPageUrl] = useState("")
  const [prevPageUrl, setPrevPageUrl] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(0)
  
  // Initial data load
  useEffect(() => {
    call()
  }, [])
  
  // Data fetching function
  const call = async () => {
    setLoadingMessage(true)
    try {
      const response = await axios.get(
        `${API_URL}/admin/reports/customer-reports?to=${toDate}&from=${fromDate}`
      )
  
      const data = response.data.data || []
      setCustomerReports(data)
  
      // Check if we have the new format with meta
      if (response.data.meta) {
        // New format with meta
        setTotal(response.data.meta.total || 0)
        setCurrentPage(response.data.meta.page || 1)
        setLastPage(response.data.meta.total_pages || 1)
        setNextPageUrl(response.data.meta.page < response.data.meta.total_pages ? 
          `?page=${response.data.meta.page + 1}` : null)
        setPrevPageUrl(response.data.meta.page > 1 ? 
          `?page=${response.data.meta.page - 1}` : null)
          
        // Set summary data if available
        if (response.data.meta.summary) {
          setTotalNewUsers(response.data.meta.summary.total_new_users || 0)
          setTotalBets(response.data.meta.summary.total_bets || 0)
          setTotalStakes(response.data.meta.summary.total_stakes || 0)
          setTotalWonStakes(response.data.meta.summary.total_won_stakes || 0)
        }
      } else {
        // Old format directly in response
        setTotal(response.data.total || 0)
        setNextPageUrl(response.data.next_page_url || "")
        setPrevPageUrl(response.data.previous_page_url || "")
        setCurrentPage(response.data.current_page || 1)
        setLastPage(response.data.last_page || 1)
        
        // Use summary if available, otherwise calculate from data
        if (response.data.summary) {
          setTotalNewUsers(response.data.summary.total_new_users || 0)
          setTotalBets(response.data.summary.total_bets || 0)
          setTotalStakes(response.data.summary.total_stakes || 0)
          setTotalWonStakes(response.data.summary.total_won_stakes || 0)
        } else {
          // Fall back to calculating from data
          const newUsersCount = data.length || 0
          const totalBetsCount = data.reduce((acc, report) => acc + (report.bets || 0), 0)
          const totalStakesCount = data.reduce((acc, report) => acc + (report.total_stake || 0), 0)
          const totalWonStakesCount = data.reduce((acc, report) => acc + (report.total_won_stake || 0), 0)
  
          setTotalNewUsers(newUsersCount)
          setTotalBets(totalBetsCount)
          setTotalStakes(totalStakesCount)
          setTotalWonStakes(totalWonStakesCount)
        }
      }
    } catch (error) {
      console.error("Error fetching customer report data:", error)
      setCustomerReports([])
    } finally {
      setLoadingMessage(false)
    }
  }
  
  // Set up pagination click handler
  useEffect(() => {
    const handlePaginationClick = function(e) {
      e.preventDefault()
      e.stopPropagation()
      setLoadingMessage("1")

      let page = $(this).text()
      
      // Handle pagination navigation
      if (page === ">") {
        if (currentPage < lastPage) {
          page = currentPage + 1
        } else {
          setLoadingMessage("0")
          return
        }
      } else if (page === ">>") {
        page = lastPage
      } else if (page === "<") {
        if (currentPage > 1) {
          page = currentPage - 1
        } else {
          setLoadingMessage("0")
          return
        }
      } else if (page === "<<") {
        page = 1
      }

      // Fetch the new page
      // Fetch the new page
      axios({
        method: "get",
        url: `${API_URL}/admin/reports/customer-reports?page=${page}&to=${toDate}&from=${fromDate}`,
      })
        .then(function (response) {
          // New structure handling
          const data = response.data.data || []
          setCustomerReports(data)
          
          // Access summary data from the meta object
          if (response.data.meta && response.data.meta.summary) {
            const summary = response.data.meta.summary
            setTotalNewUsers(summary.total_new_users || 0)
            setTotalBets(summary.total_bets || 0)
            setTotalStakes(summary.total_stakes || 0)
            setTotalWonStakes(summary.total_won_stakes || 0)
          }
          
          // Set pagination metadata
          if (response.data.meta) {
            setTotal(response.data.meta.total || 0)
            setCurrentPage(response.data.meta.page || 1)
            setLastPage(response.data.meta.total_pages || 1)
            
            // These might need to be constructed based on the current page and total pages
            const nextPage = response.data.meta.page < response.data.meta.total_pages ? 
              response.data.meta.page + 1 : null;
            const prevPage = response.data.meta.page > 1 ? 
              response.data.meta.page - 1 : null;
              
            setNextPageUrl(nextPage ? `?page=${nextPage}` : null)
            setPrevPageUrl(prevPage ? `?page=${prevPage}` : null)
          }
          
          // Update UI pagination state
          $("ul.pagination li").removeClass("active")
          $(`ul.pagination li[title="${response.data.meta.page}"]`).addClass("active")
          
          // Enable/disable navigation buttons
          if (response.data.meta.page > 1) {
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').removeClass("disabled")
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').removeClass("disabled")
          } else {
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').addClass("disabled")
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').addClass("disabled")
          }
          
          if (response.data.meta.page < response.data.meta.total_pages) {
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="next page"]').removeClass("disabled")
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="last page"]').removeClass("disabled")
          } else {
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="next page"]').addClass("disabled")
            $('.pagination.react-bootstrap-table-page-btns-ul li[title="last page"]').addClass("disabled")
          }
          
          setLoadingMessage("0")
        })
        .catch(function (error) {
          console.error("Error fetching page:", error)
          setLoadingMessage("0")
        })
    }
    
    // Add event listener
    $(document).off("click", "ul.pagination li a").on("click", "ul.pagination li a", handlePaginationClick)
    
    // Cleanup when component unmounts
    return () => {
      $(document).off("click", "ul.pagination li a")
    }
  }, [currentPage, lastPage, toDate, fromDate])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Customers Report" />
        </Container>
        <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total New Users
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totalNewUsers}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total Bets
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">{totalBets}</CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total Stakes
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalStakes.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total Won Stakes
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalWonStakes.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <FiltersCard
          toDate={toDate}
          fromDate={fromDate}
          setToDate={setToDate}
          setFromDate={setFromDate}
          call={call}
          notDisplayFilter={true}
          hideShowType={false}
        />
        <Table
          toDate={toDate}
          fromDate={fromDate}
          data={customerReports}
          loadingMessage={loadingMessage}
          setLoadingMessage={setLoadingMessage}
          total={total}
          currentPage={currentPage}
          setPrevPageUrl={setPrevPageUrl}
          prevPageUrl={prevPageUrl}
          nextPageUrl={nextPageUrl}
          setNextPageUrl={setNextPageUrl}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(CustomersReport)